/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2022 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:

// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  // auto expand
  function autoExpand(){
      setTimeout(function() {
          var hash = window.location.hash;
          if (hash && window.outerWidth <= 900) {
              hash = hash.replace('#', '');
              var el = document.querySelector('.' + hash);
              if (!el) {
              el = document.querySelector('#' + hash)
              }
              if (!el) return;
              var item = el.closest('.accordion__item');
              var title = item.querySelector('.anchor-content__heading');
              title.classList.add('js-accordion-open');
              title.setAttribute('aria-expanded', 'true');
              var body = item.querySelector('.accordion__content');
              body.removeAttribute('style');
          }
      }, 1250);
  }
  $(function(){
      autoExpand();
  });
// Default accordion
// Reflect the open state on the control the user actually operates: the button
// inside the heading, or the heading itself when there is no button.
function setTitleExpanded($title, isOpen) {
  var $button = $title.find('.accordion__button');
  var $target = $button.length ? $button : $title;
  $target.attr('aria-expanded', isOpen ? 'true' : 'false');
}

function syncTitleExpanded() {
  $('.accordion .accordion__title').each(function () {
    setTitleExpanded($(this), $(this).hasClass('js-accordion-open'));
  });
}

$('.accordion .accordion__title').click(function (e) {
  $('.accordion .accordion__title').removeClass('js-accordion-open');
  $('.accordion .accordion__content').slideUp();
  if ($(this).next().is(':hidden') == true) {
    $(this).addClass('js-accordion-open');
    $(this).next().slideDown();
  }
  syncTitleExpanded();
  e.preventDefault();
});

if ($('.accordion').hasClass('accordion--grad')) {
  $('.accordion--grad .accordion__content').hide();
  $('.accordion--grad .accordion__item:first-child .accordion__content').show();
  $('.accordion--grad .accordion__item:first-child .accordion__title').addClass(
    'js-accordion-open',
  );
} else {
  $('.accordion .accordion__content').hide();
}

syncTitleExpanded();

let isAccordionInitialized = false;

function mobOnlyAccordion() {
  function toggleItem($currentTitle) {
    var $currentContent = $currentTitle.next('.accordion__content');

    // Check if the clicked accordion title is within a nested accordion
    var isNestedAccordion = $currentTitle.closest('.accordion__content').length > 0;

    // Check if the current item is already open
    var isAlreadyOpen = $currentTitle.hasClass('js-accordion-open');

    if (isNestedAccordion) {
      // If it's a nested accordion, only toggle its own state
      if (isAlreadyOpen) {
        $currentTitle.removeClass('js-accordion-open').attr('aria-expanded', 'false');
        $currentContent.stop(true, true).slideUp();
      } else {
        $currentTitle.addClass('js-accordion-open').attr('aria-expanded', 'true');
        $currentContent.stop(true, true).slideDown();
      }
    } else {
      // If it's not a nested accordion, close other top-level items first
      $('.accordion--mob-only > .accordion__item > .accordion__title').not($currentTitle)
        .removeClass('js-accordion-open')
        .attr('aria-expanded', 'false');
      $('.accordion--mob-only > .accordion__item > .accordion__content').not($currentContent).stop(true, true).slideUp();

      // Toggle the current top-level item
      if (isAlreadyOpen) {
        $currentTitle.removeClass('js-accordion-open').attr('aria-expanded', 'false');
        $currentContent.stop(true, true).slideUp();
      } else {
        $currentTitle.addClass('js-accordion-open').attr('aria-expanded', 'true');
        $currentContent.stop(true, true).slideDown();
      }
    }
  }

  $('.accordion--mob-only .accordion__title').off('click keydown').on('click', function (e) {
    e.preventDefault();
    toggleItem($(this));
  }).on('keydown', function (e) {
    // role=button doesn't get Enter/Space activation for free the way <button> does.
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      toggleItem($(this));
    }
  });
}

function mobOnlyAccordionInit() {
  $('.accordion--mob-only').each(function () {
    var mobAccordionItemSectionClass = $(this).data('accordion-section');
    var mobAccordionItemTitleClass = $(this).data('accordion-title');
    var mobAccordionItemContentClass = $(this).data('accordion-content');
    var mobAccordionItemSection = $(this).find("." + mobAccordionItemSectionClass);
    var mobAccordionItemTitle = $(this).find("." + mobAccordionItemTitleClass);
    var mobAccordionItemContent = $(this).find("." + mobAccordionItemContentClass);

    if($(window).width() < 900){
      if (!mobAccordionItemSection.hasClass('accordion__item')){
        mobAccordionItemSection.addClass('accordion__item');
      };
      if (!mobAccordionItemTitle.hasClass('accordion__title')){
        mobAccordionItemTitle.addClass('accordion__title');
      };
      if (!mobAccordionItemContent.hasClass('accordion__content')){
        mobAccordionItemContent.addClass('accordion__content').hide();
      };

      // Heading is interactive only at this breakpoint — expose button semantics to AT.
      mobAccordionItemTitle.each(function (i) {
        var $title = $(this);
        var $content = $title.next('.accordion__content');
        var contentId = $content.attr('id');
        if (!contentId) {
          contentId = 'accordion-panel-' + Date.now() + '-' + i;
          $content.attr('id', contentId);
        }
        $title.attr({
          'role': 'button',
          'tabindex': '0',
          'aria-expanded': $title.hasClass('js-accordion-open') ? 'true' : 'false',
          'aria-controls': contentId
        });
      });

      mobOnlyAccordion();
    } else {
      mobAccordionItemSection.removeClass('accordion__item');
      mobAccordionItemTitle.removeClass('accordion__title');
      mobAccordionItemContent.removeClass('accordion__content').show();
      mobAccordionItemTitle.removeAttr('role tabindex aria-expanded aria-controls');
    }
  });
}

function debounceResize() {
  const newWindowWidth = $(window).width();

  if ((newWindowWidth < 900 && !isAccordionInitialized) || (newWindowWidth >= 900 && isAccordionInitialized)) {
    isAccordionInitialized = newWindowWidth < 900;

    if (newWindowWidth < 900) {
      mobOnlyAccordionInit();
    } else {
      $('.accordion--mob-only .accordion__title').removeClass('js-accordion-open');
      $('.accordion--mob-only .accordion__content').show();
      mobOnlyAccordionInit();
    }
  }
}

isAccordionInitialized = $(window).width() < 900;

$(window).resize(debounceResize);

if (isAccordionInitialized) {
  mobOnlyAccordionInit();
}

var fadProfileAnchor = $('.fad-profile-card__overall-rating a[href^="#"]');
if (fadProfileAnchor.length > 0) {
  fadProfileAnchor.on('click', function() {
    console.log('you dun did clicked');
    var targetDiv = $($(this).attr('href')).next();
    var siblingDiv = targetDiv.next('.anchor-content__content');

    // Remove existing classes and slide up all content
    $('.anchor-content__heading').not(targetDiv).removeClass('js-accordion-open');
    $('.anchor-content__content').not(siblingDiv).slideUp();

    // If it wasn't open, add class and slide down
    if (!targetDiv.hasClass('js-accordion-open')) {
        targetDiv.addClass('js-accordion-open');
        siblingDiv.slideDown();
    }
  });
}

}(jQuery));
